<template>
	<div class="card">
		<div class="flex">
			<div class="left">
				<div class="image" :style="`background-image: url('${image}');`"></div>
			</div>
			<div class="right">
				<header>
					<img src="@/assets/images/logo-pow.jpg" alt="">
					<h2>princeofwaleshosp_foundation</h2>
				</header>
				<main>
					<p v-html="$options.filters.truncate(message, 600)"/>
				</main>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		message: {
			type: String,
			default: '',
			required: true,
		},
		image: {
			type: String,
			default: '',
			required: false,
		},
	},
};
</script>

<style lang=less scoped>
	@import (reference) '../assets/less/default.less';
	@import '../assets/less/components/cards.less';

	.card { min-width: 100vw/4; width: 100vw/4; }
	.left { position: relative; width: 50%; height: 100%;
		&:before { .top-left(calc(50% - 16px), calc(50% - 35px), 1); display: block; content: "Loading..."; padding-top: 32px; .size(70px, 32px); background: transparent url('../assets/images/loading.svg') 0 0 / contain no-repeat; color: @red; font-size: .8rem; text-align: center; }
		.image { position: relative; z-index: 2; .size(100%); background: transparent url('') 50% 50%/cover no-repeat; }
	}
	.right { width: 50%; height: 90%; padding: 0 1rem; overflow: hidden;
		header { border-bottom: 1px solid #D2D2D2; padding-bottom: 1rem/2;
			img, h2 { display: inline-block; vertical-align: middle; font-size: 14/16rem; }
			h2 { transform: translateY(-2px); }
			img { .size(37px); border-radius: 50%; border: 1px solid #D2D2D2; }
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/CardInstagram.vue